import React, { useEffect, useMemo, useState } from "react";
import { HomeWrapper } from "../../../components/business/CdBalance/style";
import http from "../../../services/httpService";
import { Root } from "../ViewCd/styles";
import { OverlayLoader } from "../../../components";
import { Ptag } from "../../../components/fonts";
import { colors } from "../../../theme";
import Level from "./level";
import styled from "styled-components";
import TextInline from "./TextInLine";
import ServicingManager from "./ServicingManager";

function ClaimSupport() {
  const [tpaName, setTpaName] = useState("");
  const [tpas, setTpas] = useState();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getTpaDetails();
  }, []);
  const getTpaDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await http.get("dashboard/get_support_details/", {
        params: { flow: "company" },
      });
      setTpaName(data.claims_details.tpa_name);
      setTpas(data);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };
  const cashlessClaims = useMemo(() => {
    if (!tpas || !tpas.claims_details || !tpas.claims_details.cashless_details)
      return [];
    const detail = Object.groupBy(
      tpas.claims_details.cashless_details,
      ({ cashless_level }) => cashless_level
    );
    return Object.values(detail);
  }, [tpas]);

  const escalationDetails = useMemo(() => {
    if (
      !tpas ||
      !tpas.claims_details ||
      !tpas.claims_details.escalation_details
    )
      return [];

    const detail = Object.groupBy(
      tpas.claims_details.escalation_details,
      ({ escalation_level }) => escalation_level
    );
    return Object.values(detail);
  }, [tpas]);

  const RenderContacts = (header, cashlessClaim, data) => {
    return (
      <>
        <Ptag
          fontWeight="700"
          fontSize="24px"
          marginBottom="24px"
          marginTop="5rem"
          color={colors.primaryColor}
        >
          {header}
        </Ptag>
        <Level data={data} cashlessClaim={cashlessClaim} />
      </>
    );
  };

  const neoManagers = useMemo(() => {
    if (!tpas) return [];
    if (
      tpas.relationship_manager.length > 0 ||
      tpas.servicing_manager.length > 0
    ) {
      return [...tpas.servicing_manager, ...tpas.relationship_manager];
    }
  }, [tpas]);
  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <HomeWrapper style={{ marginLeft: "0px", padding: "4rem" }}>
            <WidthLimiter>
              <Ptag
                fontWeight="700"
                fontSize="24px"
                marginBottom="24px"
                // marginTop="5rem"
                color={colors.primaryColor}
              >
                Administrator
              </Ptag>
              {tpaName && <TextInline name={tpaName} />}
              {cashlessClaims.length > 0 &&
                RenderContacts("Contact Details", "cashless", cashlessClaims)}
              {escalationDetails.length > 0 &&
                RenderContacts(
                  "Escalation Matrix",
                  "escalation",
                  escalationDetails
                )}
            </WidthLimiter>
          </HomeWrapper>
          <HomeWrapper style={{ marginLeft: "0px", padding: "4rem" }}>
            <WidthLimiter>
              <Ptag
                fontWeight="700"
                fontSize="24px"
                marginBottom="24px"
                color={colors.primaryColor}
              >
                Contacts for Neo Risk Management and Insurance Broker
              </Ptag>
              <ServicingManager data={neoManagers} />
            </WidthLimiter>
          </HomeWrapper>
        </>
      )}
    </>
  );
}

export default ClaimSupport;

const WidthLimiter = styled.div`
  max-width: 800px;
`;
